export default __webpack_public_path__ + "static/media/not-found.fafcd8e8.jpg";